import { mapGetters } from 'vuex';

import reportFilters from './reportFilters/index.vue';
import reportErrosItem from './reportErrosItem/index.vue';

import pagination from '@/components/pagination/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import Api from '@/utils/api';

export default {
  props: {
    report: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    reportErrosItem,
    reportFilters,
    preloader,
    empty,
    pagination,
  },
  data () {
    return {
      errorData: [],
      responseData: [],

      usedMetarules: [],
      errorWeightValues: [],
      selectCategory: [],
      selectSeverity: [],
      selectMetarule: [
        {
          'id': 0,
          'name': '-',
        },
      ],
      loading: true,

      query: {
        id: this.$route.params.id,
        page: 1,
        perPage: 5,
      },

      sortColumn: null,
      sortDirection: '',

      showCommentLine: false,
      showCommentLineData: [],
      showCommentPreloader: false,

      sortByName: '',
      sortBy: '',

      refreshKey: 0,

      filterParams: {},

      showComment: '',
    };
  },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
  },
  created () {
    this.getProjectErrors();
  },
  methods: {
    /**
         * Method for send filters
         */
    sendFilters (params = null) {
      this.query.page = 1;
      this.filterParams = params;
      this.getProjectErrors();
    },

    /**
         * Transform params for query
         */
    transformQuery () {
      this.filterParams.SortDirection = this.sortBy;
      this.filterParams.SortField = this.sortByName;
      const query = {
        ...this.query,
        params: this.filterParams,
      };

      return query;
    },

    /**
         * Work for comments
         */
    toggleComment (id, type) {
      this.showCommentLine = (this.showCommentLine == id) ? false : id;

      this.showComment = type;

      if (type) {
        this.showCommentPreloader = true;

        Api.reports
          .getErrorsItemComment(id)
          .then((data) => {
            if (data.data.Status) {
              this.showCommentLineData = data.data.Data;
              this.showCommentPreloader = false;
            }
          });
      }
    },

    sortingColumns (nameSort) {
      this.sortByName = nameSort;
      if (this.sortBy === '') {
        this.sortBy = 'asc';
      } else if (this.sortBy === 'asc') {
        this.sortBy = 'desc';
      } else if (this.sortBy === 'desc') {
        this.sortBy = 'asc';
      }
      this.getProjectErrors();
    },

    /**
         * Method for remove error element
         */
    removeErrorItemHolder (id, rating) {
      var removeItem;

      this.errorData.forEach((el, i) => {
        if (el.ID === id) {
          removeItem = i;
        }
      });

      this.$nextTick(() => {
        this.errorData.splice(removeItem, 1);
      });

      this.report.Rating = rating;
    },

    getProjectErrors () {
      this.loading = true;
      this.selectCategory = [];
      this.selectSeverity = [];
      this.selectMetarule = [
        {
          'id': 0,
          'name': '-',
        },
      ];

      Api.reports
        .getErrorsItem(this.transformQuery())
        .then((data) => {
          if (data.data.Status) {
            this.errorData = data.data.Data;
            this.responseData = data.data;
          } else {
            this.errorData = [];
            this.responseData = [];

            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });

            this.loading = false;
            return;
          }

          const maxErrorWeight = Math.max.apply(Math, this.errorData.map((e) => { return e.ErrorWeight; }));
          for (let i = 0; i < maxErrorWeight; i++) {
            this.errorWeightValues.push(i + 1);
          }

          this.errorData.forEach((val) => {
            val.Hide = false;
          });

          this.convertSelectArray();

          this.loading = false;

          this.refreshKey += 1;
        });
    },

    /**
         * Rerender items (from paginate)
         */
    sendPage (page) {
      this.query.page = page;
      this.getProjectErrors();
    },

    /**
         * Converting data for simple presentation
         */
    convertSelectArray () {
      for (const key in this.report.FilterData) {
        this.report.FilterData[key].forEach((val) => {
          if (key == 'ErrorCategories') {
            this.selectCategory.push({
              'id': val.ID,
              'name': val.Name,
              'desc': val.Description,
            });
          }
          if (key == 'Metarules') {
            var jsonMetarules = JSON.parse(val.Metarules);
            var stringMetarules = '';

            jsonMetarules.forEach((valJsonMetarules) => {
              stringMetarules += '<span>' + valJsonMetarules.CodeName + '</span>';
            });

            this.selectMetarule.push({
              'id': val.CodeId,
              'name': stringMetarules,
            });
          }
          if (key == 'Severities') {
            this.selectSeverity.push({
              'id': val.ID,
              'name': val.Name,
            });
          }
        });
      }
    },

    getMetaruleByID (id) {
      var result = {};
      this.report.FilterData.Metarules.find((el) => {
        if (el.ID === id) { result = el; }
      });
      return result;
    },

    updateErrorItemHolder (data) {
      this.$emit('updateReport', data);
    },
  },
};
